import CampaignDetailsPage from '../pages/CampaignDetails/CampaignDetailsPage'
import React from 'react'

export const CAMPAIGN_DETAILS_PATH = '/campaign-details'

export const CAMPAIGN_DETAILS_ROUTES = [
	{
		path: `${CAMPAIGN_DETAILS_PATH}/:campaignId`,
		element: <CampaignDetailsPage />,
	},
]
